import React, { Component } from 'react';
import './SubNavbar.css';
import { get, post } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button} from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class ScheduledTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduledTime: '',
      success: false,
      warning: false,
      error: false,
      error1: false,
      open_progress_bar: false,
    };
  }

  componentDidMount() {
    this.fetchUserSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.error !== prevState.error ||
        this.state.error1 !== prevState.error1 ||
        this.state.success !== prevState.success ||
        this.state.warning !== prevState.warning
    ) {
        if (
            this.state.error ||
            this.state.error1 ||
            this.state.success ||
            this.state.warning
        ) {
            setTimeout(() => {
                this.setState({
                    error: false,
                    success:false,
                    error1: false,
                    warning: false
                });
            }, 3000); // 3 second
        }
    }
}

  fetchUserSettings = async () => {
    console.log("--------EmailAddress tab---------" );
    try {
      this.startLoading();
      let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth token---------", access_token);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`
      }

      const response = await get(urls.NOTIFICATION_SETTINGS_LIST, headers);
      this.stopLoading();
      
      console.log(urls.NOTIFICATION_SETTINGS_LIST,"response of schedule fetch 1===> <", response);

      console.log(urls.NOTIFICATION_SETTINGS_LIST,"response of schedule fetch2===> <", response[0].scheduled_time);
      // Check if response is empty
      if (!response || response.length === 0) {
        console.warn("Empty response received. Setting warning state.");
        // this.setState({ warning: true }, () => {
        //   console.log("Updated warning state:", this.state.warning);
        // });
        return;
      }
      if (response !== false && (response[0].scheduled_time !== null)) {
        
        this.setState({ scheduledTime: response[0].scheduled_time });
      }
      else{
        // this.setState({ warning: true }, () => {
        //   console.log("Updated warning state:", this.state.warning);
        // });
        return;
      }
    } catch (error) {
      console.error("Error fetching user settings:", error);
      // this.setState({error1:true});
    }
  };

  jsonData = () => {
    let data = {
        "scheduled_time": this.state.scheduledTime
    }
    return JSON.stringify(data)
  }

  handleTimeChange = (event) => {
    this.setState({ scheduledTime: event.target.value });
  };

  handleSave = async() => {
    console.log("Scheduled Time Saved:", this.state.scheduledTime);
    this.startLoading();
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
                console.log("--------auth token---------", access_token);
                let headers = {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${access_token}`
                }
                console.log("--------headers---------", headers);
        let response = await post(urls.NOTIFICATION_SETTINGS_CREATE, this.jsonData(), headers);
        console.log("response of email save===> ", response);
        this.stopLoading();
        if (response!==false) {
          // alert("Settings saved successfully.");
          this.setState({success: true})
        } else {
          // alert("Error saving emails. Please try again.");
          this.setState({error: true})
        }

  };

  startLoading = () => {
    this.setState({ open_progress_bar: true})
  }
  
  stopLoading = () => {
      this.setState({ open_progress_bar: false})
  }

  render() {
    const{error, success, error1, warning} = this.state
    return (
      <div style={{marginLeft:'3%'}}>
        <>
          <div style={{marginLeft:'15%', width:'80%'}}>
              { error ? (
                          <Alert severity="error">Error saving emails. Please try again!</Alert>
                      ) : success ? (
                          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                              "Sheduled time settings saved successfully."
                          </Alert>
                      ) : warning ? (
                        <Alert severity="warning">
                            "No time is sheduled!"
                        </Alert>
                    ): error1 ? (
                                            <Alert severity="error">
                                                "Server Error occured while fetching user settings..."
                                            </Alert>
                                            ): null}
          </div>
          <div className='scheduled-time' style={{ maxWidth: "50%", marginTop: "5%" }}>
          
            <h3>Scheduled times for email delivery</h3>
            <p style={{ fontSize: "14px", marginBottom: "10px", textAlign: "justify" }}>
              Last time(s) to receive a report with detailed status information about each of the devices in
              your account current to the scheduled time of this email. You can schedule daily, weekly, or monthly emails.
            </p>
            <input
              className='timepicker'
              type='time'
              id="appt"
              name="scheduled_time"
              value={this.state.scheduledTime}
              onChange={this.handleTimeChange}
            />
            <div style={{ marginTop: "10px" }}>
              <div>
                <Button id="rowsPerPageButton" style={{marginTop:'8px'}}
                onClick={this.handleSave} 
                > Save</Button>
              </div>
            </div>
          </div>
        </>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#2d4d85', borderRadius:'100px'}}
              />
          </div>
        </Backdrop>
      </div>
    );
  }
}

export default ScheduledTime;